import { Injectable, Inject, PLATFORM_ID, makeStateKey, TransferState } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent, HttpResponse, HttpHeaders } from '@angular/common/http';

import { Observable, of } from 'rxjs';
import { tap } from 'rxjs/operators';
import { isPlatformServer } from '@angular/common';

@Injectable()
export class CacheInterceptor implements HttpInterceptor {
  constructor(
    private transferState: TransferState,
    @Inject(PLATFORM_ID) private platformId: any
  ) { }


  intercept(req: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {

    if (req.method !== 'GET') {
      return next.handle(req);
    }

    const CACHE_KEY = makeStateKey(req.url);

    if (this.transferState.hasKey(CACHE_KEY) && !req.url.includes("ngsw-bypass")) {
      const cachedResponse = this.transferState.get(CACHE_KEY, null);
      this.transferState.remove(CACHE_KEY);
      return of(new HttpResponse({ body: cachedResponse, status: 200 }));
    }

    return next.handle(req).pipe(
      tap(event => {
        if (event instanceof HttpResponse) {
          // Condición personalizada para decidir qué solicitudes almacenar
          if (this.shouldCacheRequest(req)) {
            this.transferState.set(CACHE_KEY, event.body);
          }
        }
      })
    );
  }

  shouldCacheRequest(req: HttpRequest<any>): boolean {
    // Implementa tu lógica personalizada para decidir qué solicitudes cachear
    return isPlatformServer(this.platformId)
      || req.url.includes("cards/get/deck");

  }
}


